import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
// eslint-disable-next-line import/named
import { ProgramItem as ProgramItemType } from '../types'
import { getItemSpacingLeft, getItemWidth } from '../calculateSpace'
import config from '../config'
import { RootState } from '../../../store'
import { DateTime } from '../../../utils/datetime'
import ProgramItem from './ProgramItem'

const S = {
    ItemWrapper: styled.div<{item: ProgramItemType, selectedDate: DateTime}>`
        height: ${config.rowHeight}px;
        position: absolute;
        margin-left: ${({ item, selectedDate }) => getItemSpacingLeft(item, selectedDate)};
        width: ${({ item }) => getItemWidth(item)};
        z-index: 9;
        overflow: hidden;
    `,
}

const TimetableItem = (item: ProgramItemType) => {
    const selectedDate = useSelector(({ timetable }: RootState) => timetable.date)
    return (
        <S.ItemWrapper item={item} selectedDate={selectedDate}>
            <ProgramItem item={item} alwaysShowInfo />
        </S.ItemWrapper>
    )
}

export default TimetableItem
